/**
 * iwo通知公告路由
 * Bai.Zhiming
 * 2019-6-27
 */
angular.module('iwoNoticeRouter', []).config([
    '$stateProvider',
    function($stateProvider) {
        $stateProvider
            .state('front.editctr.iWo.notice', {
                url: '/notice',
                views: {
                    'main@front.editctr': {
                        templateUrl: './editingCenter/iWo/notice/notice_tpl.html',
                        controller: 'iwoNoticeCtrl',
                    },
                },
            })
            .state('front.editctr.iWo.notice.manage', {
                url: '/manage?noticeid&status',
                views: {
                    'create@front.editctr.iWo.notice': {
                        templateUrl: './editingCenter/iWo/notice/notice_manage_tpl.html',
                        controller: 'iwoNoticeManageCtrl',
                    },
                },
            })
            .state('front.editctr.iWo.notice.create', {
                url: '/create?noticeid&status',
                views: {
                    'create@front.editctr.iWo.notice': {
                        templateUrl: './editingCenter/iWo/notice/create/create_tpl.html',
                        controller: 'iwoNoticeCreateCtrl',
                    },
                },
            })
            .state('iwonoticedetail', {
                url: '/iwonoticedetail?noticeid',
                views: {
                    '': {
                        templateUrl: './editingCenter/iWo/notice/noticeDetail/noticeDetail_tpl.html',
                        controller: 'iwoNoticeDetailCtrl',
                    },
                },
            });
    },
]);
